export const isLastArrElement = (arr: any[], index: number) => {
	return arr.length - 1 === index;
};
